// extracted by mini-css-extract-plugin
export default {"container":"lp-z","heading":"mp-z","text":"np-z","info":"op-z","link":"pp-z","fullMaxWidth":"qp-z"};